import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-accounting',
    templateUrl: './accounting.component.html',
    styleUrls: ['./accounting.component.scss'],
    standalone: false
})
export class AccountingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  

}
